module.exports = __webpack_public_path__ + "img/sleep.69bfdc07.svg";